import { ChannelsState } from './types';

export const initialState: ChannelsState = {
  channels: null,
  loadingChannels: false,
  addingGlobalChannelToUser: false,
  updateChannelError: false,
};
